const deleteItemStorage = (keyName) => {
  sessionStorage.removeItem(keyName);
}

export default deleteItemStorage;
